import {CdkStepperModule} from '@angular/cdk/stepper';
import {Component, forwardRef} from '@angular/core';
import {StepperComponent} from '../stepper.component';

@Component({
  selector: 'app-order-stepper',
  templateUrl: './order-stepper.component.html',
  imports: [forwardRef(() => StepperComponent), CdkStepperModule],
})
export class OrderStepperComponent {}
